/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/prototype/4a0e48c/screen/57753551?
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import moment from 'moment';
import AdsCard from '@components/AdsCard';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import cx from 'classnames';
import Icon from '@components/@core/Icon';
import CommunityActions from '~/actions/community';
import { useNavigate } from 'react-router-dom';

const RecentForum = ({ displayMenu, recentTopic, title, adsList, loading }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const appId = useSelector((state) => state.app.user?.community_user?.id);
    const user = useSelector((state) => state.app.user?.community_user);
    const subStatus = useSelector((state) => state.community.subStatus);

    const [visible, setVisible] = useState(false);
    const [adsIdx, setAdsIdx] = useState(Math.round(Math.random() * adsList.length));

    useEffect(() => {
        const content_id = recentTopic.map((x) => x.id);
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id, source: 'home', type: 'impression' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload, loading));
    }, []);

    useEffect(() => {
        setAdsIdx(Math.round(Math.random() * adsList.length));
    }, [adsList.length]);

    const handleClickTopic = (e) => {
        const payload = {
            data: {
                community_user_id: user?.id,
                events: [{ content_id: e.id, source: 'home', type: 'click' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload));
        navigate(`/community/forums/${e.id}/${e.categories && e.categories[0].id}`);
    };

    const handleClickTitle = () => {
        navigate(`/forums`);
    };
    const adsData = adsList[adsIdx];

    return (
        <div className="recent-forum card">
            <broadstreet-zone zone-id="99536"></broadstreet-zone>
            <div className="dsl-b18 bold px-3 mb-5" onClick={handleClickTitle}>
                {title}
            </div>
            {subStatus.includes('pending-forum') ? (
                <div className="space">
                    <PulseLoader className={18} loading color={'#376caf'} size={18} />
                </div>
            ) : recentTopic?.length > 0 ? (
                <>
                    {recentTopic.map(
                        (item, index) =>
                            (visible ? true : index < 7) &&
                            (adsData && index == 2 ? (
                                <AdsCard key={`ads-${index}`} className="forum-item" size="tiny" data={adsData} />
                            ) : (
                                <div className="d-flex forum-item" key={index} onClick={() => displayMenu && handleClickTopic(item)}>
                                    <div className="d-h-start">
                                        <Avatar
                                            className="mr-3"
                                            url={item.comments[0]?.author_avatar}
                                            name={`${item.comments[0]?.user?.first_name} ${item.comments[0]?.user?.last_name}`}
                                            isSponsored={true}
                                        />
                                    </div>
                                    <div className="d-flex d-flex-1">
                                        <div className="d-flex-5">
                                            <p className="dsl-b14 bold truncate-one mb-0">{item.name}</p>
                                            <span className="mr-1 dsl-m12 text-400">{`Created by: ${item.comments[0]?.user?.first_name} ${item.comments[0]?.user?.last_name}`}</span>
                                            {displayMenu && !title && <span className="mr-1 dsl-m12 text-400">In: {item.categories && item.categories[0].name}</span>}
                                            <div className="d-flex">
                                                <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                                                <span className="dsl-d12 me-4">{item.stats?.views || 0}</span>
                                                <Icon name="fas fa-thumbs-up me-2 text-500" size={12} color={item.stats?.liked && appId && item.stats?.liked[appId] ? '#376caf' : '#969faa'} />
                                                <span className={cx('dsl-d12 me-4', item.stats?.liked && appId && item.stats?.liked[appId] && 'forums-count')}>{item.stats?.likes || 0}</span>
                                                <Icon name="far fa-comment me-2 text-500" size={12} color={item?.comments.some((comment) => comment.user_id === appId) ? '#376caf' : '#969faa'} />
                                                <span className={cx('dsl-d12 me-4', item?.comments.some((comment) => comment.user_id === appId) && 'forums-count')}>{item.stats?.comments || 0}</span>
                                            </div>
                                        </div>
                                        <div className="d-flex d-flex-1 jc-end">
                                            {item.comments && item.comments.length > 0 && (
                                                <span className="dsl-b12 text-nowrap text-end">{moment.utc(item.comments[item.comments.length - 1].created_at).fromNow()}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                    )}
                    <Button className="ml-auto me-3" name={visible ? 'See Less' : 'See More'} type="link" onClick={() => setVisible(!visible)} />
                </>
            ) : adsData ? (
                <AdsCard className="forum-item" size="tiny" data={adsData} />
            ) : (
                <div className="dsl-m14 text-center">No recent topic available</div>
            )}
        </div>
    );
};

RecentForum.propTypes = {
    title: PropTypes.string,
    RecentTopic: PropTypes.array,
    displayMenu: PropTypes.bool,
    adsList: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            img: PropTypes.string,
            img_small__300: PropTypes.string,
            img_medium__800: PropTypes.string,
            sponsor: PropTypes.string,
            url__target: PropTypes.string,
        })
    ),
};

RecentForum.defaultProps = {
    title: null,
    RecentTopic: [],
    displayMenu: false,
    adsList: [],
};

export default RecentForum;
